import config from '../../apiConfig'

export const functionToRetrieveFromConfigFile = async () => {
  const res = (await config()) as any
  return res
}
